import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const AUDIO_DEFAULTS = {
    src: "",
    title: "Track title",
    artist: "Artist name",
    autoplay: false,
    loop: false,
    background: "#f8fafc",
    textColor: "#0f172a",
    radius: 12,
};
export const audioWidget = {
    type: "audio",
    defaultProps: AUDIO_DEFAULTS,
    renderHtml(props, ctx) {
        const url = props.src ? (ctx.resolveAssetUrl?.(props.src) ?? props.src) : "";
        const bg = props.background ?? "#f8fafc";
        const text = props.textColor ?? "#0f172a";
        const radius = props.radius ?? 12;
        if (!url) {
            return `<div class="emk-audio emk-audio--empty" style="padding:16px;background:${bg};color:#9ca3af;border:1px dashed #e5e7eb;border-radius:${radius}px;text-align:center;font-size:13px;font-family:inherit">(No audio source — paste an MP3/OGG URL in the inspector)</div>`;
        }
        const meta = props.title || props.artist
            ? `<div style="padding:14px 16px 8px;font-family:inherit">${props.title ? `<div style="font-weight:600;font-size:15px;color:${text};line-height:1.3">${escapeHtml(props.title)}</div>` : ""}${props.artist ? `<div style="font-size:13px;color:${text};opacity:0.7;margin-top:2px">${escapeHtml(props.artist)}</div>` : ""}</div>`
            : "";
        const attrs = [
            `src="${escapeAttr(url)}"`,
            "controls",
            'preload="metadata"',
            props.autoplay ? "autoplay" : "",
            props.loop ? "loop" : "",
        ]
            .filter(Boolean)
            .join(" ");
        return `<div class="emk-audio" style="background:${bg};border-radius:${radius}px;overflow:hidden;border:1px solid rgba(0,0,0,0.06);font-family:inherit">${meta}<audio ${attrs} style="display:block;width:100%;padding:${meta ? "8px 16px 14px" : "14px 16px"};box-sizing:border-box"></audio></div>`;
    },
};
//# sourceMappingURL=audio.js.map